import axios from 'axios';

const API_URL = '/api/v1/auth/';

class AuthService {
  async login(email, password) {
    const response = await axios.post(API_URL + 'login/', {
      email,
      password
    });
    if (response.data.tokens?.access) {
      // Store the full response with user and tokens
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  }

  async register(userData) {
    const response = await axios.post(API_URL + 'register/', userData);
    if (response.data.tokens?.access) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
  }

  logout() {
    localStorage.removeItem('user');
  }

  getCurrentUser() {
    const data = localStorage.getItem('user');
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  isAuthenticated() {
    const userData = this.getCurrentUser();
    return !!(userData?.tokens?.access);
  }

  isAdmin() {
    const userData = this.getCurrentUser();
    return !!(userData?.user?.is_staff || userData?.user?.is_superuser);
  }

  getAuthHeader() {
    const userData = this.getCurrentUser();
    if (userData?.tokens?.access) {
      return { Authorization: 'Bearer ' + userData.tokens.access };
    }
    return {};
  }

  getAccessToken() {
    const userData = this.getCurrentUser();
    return userData?.tokens?.access || null;
  }

  getUserInfo() {
    const userData = this.getCurrentUser();
    return userData?.user || null;
  }
}

export default new AuthService();
